import { formatAgo, formatWhen } from '../RunDetail/runDetailFormat';
import { PLATFORM_MCP_COPY } from '../../../constants/platformMcpCopy';

/** `attach_knowledge` → "Attach knowledge". */
export const humanizeTool = (name) => {
  if (!name) return '—';
  const s = String(name).replace(/_/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
};

/** 212 → "0.2 s", 1850 → "1.9 s", 12500 → "13 s". */
export const formatLatency = (ms) => {
  const n = Number(ms);
  if (ms === null || ms === undefined || !Number.isFinite(n)) return '—';
  const s = n / 1000;
  return `${s < 10 ? s.toFixed(1) : Math.round(s)} s`;
};

/**
 * Result chip for a call `status`. Unknown values fall through as plain text
 * (`tone: null`) so a new backend status still shows something sensible.
 */
export const statusMeta = (status) => {
  switch (status) {
    case 'ok':
      return { label: 'Success', tone: 'success' };
    case 'error':
      return { label: 'Failed', tone: 'danger' };
    case 'cancelled':
      return { label: 'Stopped', tone: 'neutral', tip: PLATFORM_MCP_COPY.stoppedTip };
    default:
      return { label: status || '—', tone: null };
  }
};

/** "ChatGPT …x9Qa"; "Unknown" when the key (or its user) was deleted. */
export const appLabel = (key) => {
  if (!key) return PLATFORM_MCP_COPY.unknown;
  const name = key.name || PLATFORM_MCP_COPY.unnamedKey;
  return key.last4 ? `${name} …${key.last4}` : name;
};

export const userLabel = (user) => {
  if (!user) return PLATFORM_MCP_COPY.unknown;
  return user.name || user.email || `User #${user.id}`;
};

/**
 * `last_used_at` is refreshed at most every 5 minutes, so anything recent is
 * shown as "a few minutes ago" rather than a precise-looking "2m ago".
 */
export const roughLastUsed = (iso) => {
  if (!iso) return PLATFORM_MCP_COPY.never;
  const mins = (Date.now() - new Date(iso).getTime()) / 60000;
  if (Number.isNaN(mins)) return '—';
  if (mins < 10) return 'A few minutes ago';
  return formatAgo(iso) || formatWhen(iso);
};

export const formatDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString();
};

/** "1 call · 1 failed" from the response `summary` (counts the whole period). */
export const summaryText = (summary, total) => {
  const calls = summary?.calls ?? total ?? 0;
  const errors = summary?.errors ?? 0;
  return `${calls} ${calls === 1 ? 'call' : 'calls'} · ${errors} failed`;
};

/** The period the backend actually used (ranges past 30 days are cut). */
export const rangeText = (range) => {
  if (!range?.start || !range?.end) return '';
  const fmt = (iso) => {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  };
  return `${fmt(range.start)} – ${fmt(range.end)}`;
};
